<template>
<div class="vliveContentComment">
    <div class="content-comment left">
        <div><img :src="user.logourl" alt="" class="logo"></div>
        <div class="content-comment-detail">
            <div class="user">资鲸</div>
            <div class="box">我是主持人</div>
        </div>
    </div>
    <div class="content-comment right">
        <div class="content-comment-detail">
            <div class="user">资鲸</div>
            <div class="box" :style="'background:'+vliveModel.contentthemecolor">我是主持人</div>
        </div>
        <div><img :src="user.logourl" alt="" class="logo"></div>
    </div>
    <div class="content-comment left">
        <div><img :src="user.logourl" alt="" class="logo"></div>
        <div class="content-comment-detail">
            <div class="user">资鲸</div>
            <div class="box">我是主持人</div>
        </div>
    </div>
    <div class="content-comment right">
        <div class="content-comment-detail">
            <div class="user">资鲸</div>
            <div class="box" :style="'background:'+vliveModel.contentthemecolor">我是主持人</div>
        </div>
        <div><img :src="user.logourl" alt="" class="logo"></div>
    </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'vliveContentComment',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContentComment {
    // width: 375px;111
    width: 266px;
    border: 1px dashed $bgcolor-grey;
    background: $line;
    .left{
        @include flexBox(flex-start);
        text-align: left;
        .box{
            background: $bgcolor-white;
        }
    }
    .right{
        @include flexBox(flex-end);
        text-align: right;
        .box{
            background: $bgcolor-base;
            color: $tcolor-white;
        }
    }
    .content-comment{
        margin: 20px 10px;
        .content-comment-detail{
            .user{
                padding: 10px 0;
            }
            .box{
                box-sizing: border-box;
                padding: 10px;
                border-radius: 8px;
                max-width: 200px;
                overflow: hidden;
            }
        }
        .logo{
            width: 36px;
            height: 36px;
            margin: 10px;
        }
    }
}
</style>
